import React, { Component, Fragment } from 'react'
import Datetime from 'react-datetime';
import moment from 'moment';
import { date_format } from '../../../server/constants';
import NumberBox from '../../Misc/NumericBox';
import { _addNotificationError, getSalesTaxStatus } from '../../../server/util'

export default class cutoffDays extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedDate: null,
            dayOfMonth: this.props.dayOfMonth,
            dateSelected: this.props.mealObj.dateSelected,
            sideSelectionAllowedDuringPreOrder: this.props.mealObj.sideSelectionAllowedDuringPreOrder || false,
            isExtraPreOrder: this.props.mealObj.preOrderingOfAlacarteItemsAllowed || false,
            cutOffDateTime: this.props.mealObj.cutOffDateTime,
            weeklyOrderCutOffDay: this.props.mealObj.dayOfWeek || '',
            daySelected: this.props.mealObj.daySelected,
            noOfDaysBeforeSelected: this.props.noOfDaysBeforeSelected,
            allowOrderNDaysBefore: this.props.mealObj.numberOfDaysBefore == 0 ? 0 : this.props.mealObj.numberOfDaysBefore || '',
            salesTaxPerc: this.props.mealObj.salesTaxRate || 0.00,
            cutOffType: (this.props.mealObj.dateSelected) ? 'M' : (this.props.mealObj.daySelected) ? 'W' : 'R',
            timeWithMinutes: (this.props.mealObj.dateSelected) ? moment(this.props.mealObj.timeWithMinutes || undefined, 'HH:mm').isValid() ? moment(this.props.mealObj.timeWithMinutes, 'HH:mm') : moment('23:59', 'HH:mm') : moment('23:59', 'HH:mm'),
            weeklyOrderCutOffTime: (this.props.mealObj.daySelected) ? moment(this.props.mealObj.timeWithMinutes || undefined, 'HH:mm').isValid() ? moment(this.props.mealObj.timeWithMinutes, 'HH:mm') : moment('23:59', 'HH:mm') : moment('23:59', 'HH:mm'),
            allowOrderNDaysTimeBefore: (this.props.mealObj.noOfDaysBeforeSelected) ? moment(this.props.mealObj.timeWithMinutes || undefined, 'HH:mm').isValid() ? moment(this.props.mealObj.timeWithMinutes, 'HH:mm') : moment('23:59', 'HH:mm') : moment('23:59', 'HH:mm'),
            weeklyOrderCutOffDay: this.props.mealObj.weeklyOrderCutOffDay || '',
            orderDateExtensionStatus: this.props.mealObj.orderDateExtensionStatus || false,
            extraEnableForCaterer: this.props.mealObj.extraEnableForCaterer || false,
            isWeekly: this.props.isWeekly || false,
        }
        console.log("CutOffType:::::", this.state.cutOffType);
        console.log("this.props.mealObj:::::", this.props.mealObj);
    }
    cutOffChange = (e) => {
        this.setState({ cutOffDateTime: new Date(e) })
    };
    componentWillReceiveProps = (nextProps) => {
        console.log("componentWillReceiveProps ::::", nextProps);
        const { mealObj } = nextProps;
        this.setState({
            dateSelected: mealObj.dateSelected,
            dayOfMonth: mealObj.dayOfMonth,
            sideSelectionAllowedDuringPreOrder: mealObj.sideSelectionAllowedDuringPreOrder || false,
            isExtraPreOrder: mealObj.preOrderingOfAlacarteItemsAllowed || false,
            cutOffDateTime: mealObj.cutOffDateTime,
            weeklyOrderCutOffDay: mealObj.dayOfWeek || '',
            daySelected: mealObj.daySelected,
            allowOrderNDaysBefore: mealObj.numberOfDaysBefore == 0 ? 0 : mealObj.numberOfDaysBefore || '',
            salesTaxPerc: mealObj.salesTaxRate || 0.00,
            timeWithMinutes: (mealObj.dateSelected) ? moment(mealObj.timeWithMinutes || undefined, 'HH:mm').isValid() ? moment(mealObj.timeWithMinutes, 'HH:mm') : moment('23:59', 'HH:mm') : moment('23:59', 'HH:mm'),
            weeklyOrderCutOffTime: (mealObj.daySelected) ? moment(mealObj.timeWithMinutes || undefined, 'HH:mm').isValid() ? moment(mealObj.timeWithMinutes, 'HH:mm') : moment('23:59', 'HH:mm') : moment('23:59', 'HH:mm'),
            noOfDaysBeforeSelected: mealObj.noOfDaysBeforeSelected,
            allowOrderNDaysTimeBefore: (mealObj.noOfDaysBeforeSelected) ? moment(mealObj.timeWithMinutes || undefined, 'HH:mm').isValid() ? moment(mealObj.timeWithMinutes, 'HH:mm') : moment('23:59', 'HH:mm') : moment('23:59', 'HH:mm'),
            orderDateExtensionStatus: mealObj.orderDateExtensionStatus,
            extraEnableForCaterer: mealObj.extraEnableForCaterer || false,
            isWeekly: nextProps.isWeekly,
        });
        console.log("cutofType::::", this.state.cutOffType);
    }

    changeCutOffSettings(e) {
        this.setState({
            noOfDaysBeforeSelected: false,
            daySelected: false,
            dateSelected: true,
            cutOffType: 'M',
            weeklyOrderCutOffDay: '',
            weeklyOrderCutOffTime: moment('23:59', 'HH:mm'),
            allowOrderNDaysTimeBefore: moment('23:59', 'HH:mm'),
            cutOffDateTime: this.state.cutOffDateTime,
            orderDateExtensionStatus: false,
            allowOrderNDaysBefore: ''
        })
        this.props.onCutoffDateChange("dateSelected", e.target.checked);
        this.props.onCutoffDateChange("daySelected", false);
        this.props.onCutoffDateChange("dateSelected", true);
        this.props.onCutoffDateChange("noOfDaysBeforeSelected", false);

    }

    onDateChange(e) {

        this.setState({ "cutOffDateTime": new Date(e) });
        this.props.onCutoffDateChange("dayOfMonth", e.month() + 1);
        this.props.onCutoffDateChange("cutOffDateTime", new Date(e));
    }

    dateOptions = Array.from({ length: 31 }, (_, index) => ({
        value: `${index + 1}`,
        label: `${index + 1}`,
    }));
    handleDateChange = (selectedOption) => {
        this.setState({ selectedDate: selectedOption });
    };

    render() {
        const { cutOffType, dayOfMonth, cutOffDateTime, weeklyOrderCutOffDay, allowOrderNDaysBefore,
            orderDateExtensionStatus, sideSelectionAllowedDuringPreOrder, extraEnableForCaterer,
            autoReminderDate1, autoReminderDate2, weeklyOrderCutOffTime, allowOrderNDaysTimeBefore, salesTaxPerc, isExtraPreOrder, timeWithMinutes } = this.state;
        const options = Array.from({ length: 31 }, (_, index) => index + 1);
        return (
            <Fragment>
                <h4 style={{ color: '#0000b2', marginLeft: '2%', marginBottom: '0px' }}>Cut-Off Date Settings</h4>
                <form className="form-horizontal" style={{ marginLeft: '10px' }}>
                    <div className="form-group">
                        <div className="row">
                            <div className="col-md-5">
                                <div className="custom-control custom-radio" style={{ marginTop: '10px', marginLeft: '0%' }}>
                                    <input type="radio" className="custom-control-input"
                                        name="rbCutOffDate" checked={this.state.dateSelected} id="cutoffDate" onChange={(e) => this.changeCutOffSettings(e)} />
                                    <label className="custom-control-label" htmlFor="cutoffDate" style={{ marginLeft: '10px' }}>Date</label>
                                </div>
                            </div>
                            <div className="col-md-3" style={{ paddingLeft: '1%' }}>
                                <div className="uploadFileInfo createmenu-month-group">
                                    <div className="input-group" style={{ marginLeft: '0%' }}>
                                        <fieldset disabled={!this.state.dateSelected}>
                                            <select className="form-control" style={{ width: '120px' }} name="dayOfMonth"
                                                disabled={!this.state.dateSelected} id="dayOfMonth" value={this.state.dateSelected ? dayOfMonth : ''} onChange={(e) => {
                                                    this.setState({ dayOfMonth: e.target.value });
                                                    this.props.onCutoffDateChange("dayOfMonth", e.target.value);
                                                }} >
                                                <option value={''}>Select</option>
                                                {options.map((optionValue) => (
                                                    <option key={optionValue} value={optionValue}>
                                                        {optionValue}
                                                    </option>
                                                ))}
                                            </select>
                                        </fieldset>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="uploadFileInfo createmenu-month-group">
                                    <div className="input-group" style={{ marginLeft: '15%' }}>
                                        <fieldset disabled={!this.state.dateSelected}>
                                            <Datetime
                                                id="cutoffTime"
                                                timeFormat={"HH:mm"}
                                                value={timeWithMinutes}
                                                viewMode="time"
                                                dateFormat={false}
                                                onChange={(e) => {
                                                    this.setState({ timeWithMinutes: e.format("HH:mm") })
                                                    this.props.onCutoffDateChange("timeWithMinutes", e.format('HH:mm'));
                                                }}
                                                locale='en-US'
                                                closeOnSelect
                                                renderInput={(props, openCalendar, closeCalendar) => {
                                                    return (
                                                        <Fragment>
                                                            <input className="form-control" style={{ width: '50%', position: 'absolute' }} {...props} />
                                                            <button type="button" className="input-group-addon" style={{ marginLeft: '60px', width: '35%' }} onClick={openCalendar}>
                                                                <i className="fa fa-calendar" style={{ marginLeft: '40%' }}> </i>
                                                            </button>
                                                        </Fragment>
                                                    );
                                                }}
                                            />
                                        </fieldset>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="row">
                            <div className="col-md-5">
                                <div className="custom-control custom-radio" style={{ marginTop: '7px', marginLeft: '0%' }}>
                                    <input type="radio" className="custom-control-input"
                                        name="rbCutOffDate" checked={this.state.daySelected} id="wcutoffDate" onChange={(e) => {
                                            this.setState({
                                                noOfDaysBeforeSelected: false,
                                                daySelected: true,
                                                dateSelected: false,
                                                cutOffType: e.target.checked ? 'W' : 'M',
                                                weeklyOrderCutOffDay: weeklyOrderCutOffDay,
                                                weeklyOrderCutOffTime: moment('23:59', 'HH:mm'),
                                                allowOrderNDaysTimeBefore: moment('23:59', 'HH:mm'),
                                                cutOffDateTime: undefined, orderDateExtensionStatus: false,
                                                allowOrderNDaysBefore: ''
                                            })
                                            console.log("CutOffType for Week::::::::", cutOffType);
                                            console.log("cutoffType boolean::::::", (cutOffType == 'W') ? true : false);
                                            this.props.onCutoffDateChange("daySelected", true);
                                            this.props.onCutoffDateChange("dateSelected", false);
                                            this.props.onCutoffDateChange("noOfDaysBeforeSelected", false);
                                        }} />
                                    <label className="custom-control-label" htmlFor="wcutoffDate" style={{ marginLeft: '10px' }}>Weekly</label>
                                </div>
                            </div>
                            <div className="col-md-3" style={{ paddingLeft: '5px' }}>
                                <select className="form-control" style={{ width: '120px' }} value={this.state.daySelected ? weeklyOrderCutOffDay : ''} disabled={!this.state.daySelected} onChange={(e) => {
                                    this.setState({
                                        weeklyOrderCutOffDay: e.target.value,
                                        cutOffType: 'W'
                                    });
                                    this.props.onCutoffDateChange("dayOfWeek", e.target.value);
                                }}>
                                    <option value="">Select</option>
                                    <option value="Sun">Sunday</option>
                                    <option value="Mon">Monday</option>
                                    <option value="Tue">Tuesday</option>
                                    <option value="Wed">Wednesday</option>
                                    <option value="Thu">Thursday</option>
                                    <option value="Fri">Friday</option>
                                    <option value="Sat">Saturday</option>
                                </select>
                            </div>
                            <div className="col-md-4">
                                <div className="uploadFileInfo createmenu-month-group">
                                    <div className="input-group" style={{ marginLeft: '15%' }}>
                                        <fieldset disabled={!this.state.daySelected}>
                                            <Datetime
                                                id="cutoffTime"
                                                timeFormat={"HH:mm"}
                                                value={weeklyOrderCutOffTime}
                                                viewMode="time"
                                                dateFormat={false}
                                                onChange={(e) => {
                                                    this.setState({ timeWithMinutes: e.format("HH:mm") })
                                                    this.props.onCutoffDateChange("timeWithMinutes", e.format('HH:mm'));
                                                }}
                                                locale='en-US'
                                                closeOnSelect
                                                renderInput={(props, openCalendar, closeCalendar) => {
                                                    return (
                                                        <Fragment>
                                                            <input className="form-control" style={{ width: '50%', position: 'absolute' }} {...props} />
                                                            <button type="button" className="input-group-addon" style={{ marginLeft: '60px', width: '35%' }} onClick={openCalendar}>
                                                                <i className="fa fa-calendar" style={{ marginLeft: '40%' }}> </i>
                                                            </button>
                                                        </Fragment>
                                                    );
                                                }}
                                            />
                                        </fieldset>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="row">
                            <div className="col-md-5">
                                <div className="custom-control custom-radio" style={{ marginTop: '7px', marginLeft: '0%' }}>
                                    <input type="radio" className="custom-control-input"
                                        name="rbCutOffDate" checked={this.state.noOfDaysBeforeSelected} id="rcutoffDay" onChange={(e) => {
                                            this.setState({
                                                noOfDaysBeforeSelected: true,
                                                daySelected: false,
                                                dateSelected: false,
                                                cutOffType: e.target.checked ? 'R' : 'W',
                                                weeklyOrderCutOffDay: '',
                                                weeklyOrderCutOffTime: moment('23:59', 'HH:mm'),
                                                allowOrderNDaysTimeBefore: moment('23:59', 'HH:mm'),
                                                cutOffDateTime: undefined,
                                                orderDateExtensionStatus: false,
                                                allowOrderNDaysBefore: ''
                                            });
                                            this.props.onCutoffDateChange("noOfDaysBeforeSelected", e.target.checked);
                                            this.props.onCutoffDateChange("daySelected", false);
                                            this.props.onCutoffDateChange("dateSelected", false);
                                            this.props.onCutoffDateChange("noOfDaysBeforeSelected", true);
                                        }} />
                                    <label className="custom-control-label" htmlFor="rcutoffDay" style={{ marginLeft: '21px', marginTop: '-20%' }}>Allow no of days before order</label>
                                </div>
                            </div>
                            <div className="col-md-3" style={{ paddingLeft: '5px' }}>
                                <select className="form-control" style={{ width: '120px' }} name="allowOrderNDaysBefore"
                                    disabled={!this.state.noOfDaysBeforeSelected} id="allowOrderNDaysBefore" value={this.state.noOfDaysBeforeSelected ? allowOrderNDaysBefore : ''} onChange={(e) => {
                                        this.setState({ allowOrderNDaysBefore: e.target.value });
                                        this.props.onCutoffDateChange("numberOfDaysBefore", e.target.value);
                                    }} >
                                    <option value={''}>Select</option>
                                    <option value={-1}>Same Day</option>
                                    <option value={0}>0</option>
                                    <option value={1}>1</option>
                                    <option value={2}>2</option>
                                    <option value={3}>3</option>
                                    <option value={4}>4</option>
                                    <option value={5}>5</option>
                                    <option value={6}>6</option>
                                    <option value={7}>7</option>
                                </select>
                            </div>
                            <div className="col-md-4">
                                <div className="uploadFileInfo createmenu-month-group">
                                    <div className="input-group" style={{ marginLeft: '15%' }}>
                                        <fieldset disabled={!this.state.noOfDaysBeforeSelected}>
                                            <Datetime
                                                id="cutoffTime"
                                                timeFormat={"HH:mm"}
                                                value={allowOrderNDaysTimeBefore}
                                                viewMode="time"
                                                dateFormat={false}
                                                onChange={(e) => {
                                                    this.setState({ timeWithMinutes: e.format("HH:mm") })
                                                    this.props.onCutoffDateChange("timeWithMinutes", e.format('HH:mm'));
                                                }}
                                                locale='en-US'
                                                closeOnSelect
                                                renderInput={(props, openCalendar, closeCalendar) => {
                                                    return (
                                                        <Fragment>
                                                            <input className="form-control" style={{ width: '50%', position: 'absolute' }} {...props} />
                                                            <button type="button" className="input-group-addon" style={{ marginLeft: '60px', width: '35%' }} onClick={openCalendar}>
                                                                <i className="fa fa-calendar" style={{ marginLeft: '40%' }}> </i>
                                                            </button>
                                                        </Fragment>
                                                    );
                                                }}
                                            />
                                        </fieldset>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="checkbox" style={{ marginLeft: '0%' }}>
                            <label><input type="checkbox" checked={sideSelectionAllowedDuringPreOrder} onChange={(e) => {
                                this.setState({ sideSelectionAllowedDuringPreOrder: e.target.checked })
                                this.props.onCutoffDateChange("sideSelectionAllowedDuringPreOrder", e.target.checked ? true : false);
                            }} />Allow sides selection during pre-order</label>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="checkbox" style={{ marginLeft: '0%' }}>
                            <label><input type="checkbox" checked={isExtraPreOrder} onChange={(e) => {
                                this.setState({ isExtraPreOrder: e.target.checked })
                                this.props.onCutoffDateChange("preOrderingOfAlacarteItemsAllowed", e.target.checked ? true : false);
                            }} />Allow pre-ordering of A la carte items</label>
                        </div>
                    </div>
                </form>
            </Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/ManageSchools/cutoffDays.jsx